module.exports = __webpack_public_path__ + "static/media/cart.dea8624c.svg";